import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useHistory } from 'react-router-dom';
import API_BASE_URL from '../config';
import './FoodStalls.css';

const GuestFood: React.FC = () => {
    const { accessToken } = useAuth();
    const history = useHistory();
    const [counters, setCounters] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchCounters = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${API_BASE_URL}/api/food-counters`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                const data = await response.json();
                if (Array.isArray(data)) {
                    setCounters(data);
                } else {
                    setError('Failed to load food stalls');
                }
            } catch (err) {
                console.error('Error fetching counters:', err);
                setError('Failed to load food stalls');
            } finally {
                setLoading(false);
            }
        };

        if (accessToken) {
            fetchCounters();
        } else {
            history.push('/login');
        }
    }, [accessToken, history]);

    if (loading) return (
        <div className="food-stalls-section loading-state">
            <div className="shimmer-card"></div>
            <p>Loading delicacies...</p>
        </div>
    );

    return (
        <div className="guest-food-page" style={{ padding: '80px 20px 100px', minHeight: '100vh', background: '#fff' }}>
            <div className="page-header" style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '2.2rem', color: '#1a1a2e', marginBottom: '8px' }}>Dining & Treats</h1>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Choose a stall to place your digital order</p>
            </div>

            <div className="food-stalls-section" style={{ maxWidth: '600px', margin: '0 auto' }}>
                {counters.length === 0 ? (
                    <div className="empty-state" style={{ textAlign: 'center', padding: '40px' }}>
                        <span style={{ fontSize: '3rem' }}>🍽️</span>
                        <h3 style={{ marginTop: '15px' }}>Stalls are coming soon!</h3>
                        <p>Our chefs are preparing something special for you.</p>
                    </div>
                ) : (
                    <>
                        <div className="section-header-row">
                            <h3>🍲 Live Food Stalls</h3>
                            <span className="live-badge">ORDERING OPEN</span>
                        </div>
                        <div className="food-stalls-grid">
                            {counters.map(counter => (
                                <div key={counter._id} className="food-stall-card" onClick={() => {
                                    const baseUrl = process.env.REACT_APP_ORDER_MANAGER_URL || 'http://localhost:3000';
                                    window.open(`${baseUrl}/order/${counter.slug}`, '_blank', 'noopener,noreferrer');
                                }}>
                                    <div className="stall-icon">🥘</div>
                                    <div className="stall-info">
                                        <span className="stall-name">{counter.name}</span>
                                        <span className="stall-tagline">Order Digitally ⚡</span>
                                    </div>
                                    <div className="order-arrow">→</div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>

            <div className="order-help" style={{
                marginTop: '40px',
                padding: '20px',
                background: '#f8fafc',
                borderRadius: '15px',
                border: '1px dashed #cbd5e1',
                textAlign: 'center'
            }}>
                <h4 style={{ margin: '0 0 8px', color: '#334155' }}>How it works?</h4>
                <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>
                    Select a stall → Choose your items → Place order → Get notified when ready!
                </p>
            </div>
        </div>
    );
};

export default GuestFood;
